import React, {useRef} from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";
import FeaturesFiltersBody from "../../../FeatureCreator/FeaturesFilters/FeaturesFiltersBody";
import useOutsideClick from "../../../../utilities/helperHooks";
import {setFilterVisible} from "../../../FeatureCreator/FeaturesFilters/FeaturesFiltersActions";
import {
  getFeatureExcludedIndex,
  getFeatureIncludedIndex, getFeatureIsChecked,
  getFeaturesExcludedObject, getIncludedFromFeatures,
  getNewExcludedFromFeatures
} from "../../wizardFunctions";


const WizardPopupEntitiesExclusionTopFilters = (props) => {

  const {intl, renderFeatures, renderFilters, setFilterVisible, filterVisible, selectedFilters, wizardPopupGroup,
    forFeatures} = props;

  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);
  const {searchText, featuresExcluded, featuresIncluded} = wizardPopupState;
  const filtersElement = useRef(null);

  useOutsideClick(filtersElement, (event) => {
    const excludedClassNames = ["filters-body-item__expand-item", "filters-body-item", "ui-svg-checkbox__icon-checked-icon"];
    if (filterVisible
      && !excludedClassNames.some(className => event.target.closest("."+className))
      && !(event.target.parentElement && event.target.parentElement.classList.contains("employees-checkbox-circle"))) {
      setFilterVisible("");
    }
  });

  const selectAll = (selectAllFeatures) => {
    let payload;
    if (renderFeatures) {
      payload = {
        featuresExcluded: selectAllFeatures
          ? (!selectedFilters.length && !searchText) ? [] : getNewExcludedFromFeatures(featuresExcluded, renderFeatures)
          : [
            ...featuresExcluded,
            ...renderFeatures.filter(feature => getFeatureExcludedIndex(feature, featuresExcluded) === -1)
              .map(feature => getFeaturesExcludedObject(feature))
          ], // we keep it for old support
        featuresIncluded: selectAllFeatures ? [
          ...featuresIncluded,
          ...renderFeatures.filter(feature => getFeatureIncludedIndex(feature, featuresIncluded) === -1)
            .map(feature => getFeaturesExcludedObject(feature))
        ] : (!selectedFilters.length && !searchText) ? [] : getIncludedFromFeatures(featuresIncluded, renderFeatures),
      }
    } else if (renderFilters) {
      payload = {
        filtersExcluded: selectAllFeatures ? [] : renderFilters.map(filter => filter.id)
      }
    }
    console.log("payload after selectAll", payload);
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload
    })
  }

  const setSearchInput = (searchText) => {
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {searchText}
    })
  }

  const editLinkClick = () => {
    const win = window.open(`/#/`,  '_blank');
    const baseUrl = window.location.port === '9005' ? "" : "/dashboard";
    win.location.href = baseUrl + `/#/features-setup?group=${wizardPopupGroup.groupName}&catId=0`;
  }

  const totalSelected = renderFeatures
    ? renderFeatures.filter(f => getFeatureIsChecked(f, wizardPopupState))
    : [];

  return (
    <div className="wizard-popup__top">
      <div className="wizard-filtering">
        <div className="wizard-filtering__title">
          <div>{wizardPopupGroup.groupName}</div>
          <div className="ui-link flex flex--center" onClick={editLinkClick}>
            <div className="new-account-edit-icon"/>
            Manage features
          </div>
        </div>
        <div className="wizard-filtering-filters" ref={filtersElement}>
          {renderFeatures ? <FeaturesFiltersBody useDropdown={true} forFeatures={forFeatures}/> : null}
        </div>
        <div className="ui-search jb-filters__search">
          <input type="text" className={"ui-search__input" + (searchText ? " ui-search__input--no-icon" : "")}
                 placeholder={intl.formatMessage({id: "assignPopup.searchPlaceholder"})}
                 onChange={(event => setSearchInput(event.target.value))}
                 value={searchText}/>
          <span className="ui-search__icon"/>
        </div>
      </div>
      <div className="jb-filters__selections">
        <div className="jb-filters__selections-info">
          <div className="secondary">Total: {renderFeatures.length}</div>
          <div className="secondary">Selected: {totalSelected.length}</div>
          <div className="secondary">Deselected: {renderFeatures.length - totalSelected.length}</div>
        </div>
        <button className="ui-button3 ui-button3--white jb-filters__selections-button" onClick={() => selectAll(true)}>
          <FormattedMessage id="jobBoard.filters.popup.selectAllButton"/>
        </button>
        <button className="ui-button3 ui-button3--white jb-filters__selections-button" onClick={() => selectAll(false)}>
          <FormattedMessage id="jobBoard.filters.popup.deselectAllButton"/>
        </button>
      </div>
    </div>
  )
};

WizardPopupEntitiesExclusionTopFilters.propTypes = {
  renderFeatures: PropTypes.array,
  forFeatures: PropTypes.array,
  renderFilters: PropTypes.array,
};

const mapStateToProps = (store) => {
  const {filterVisible, selectedFilters} = store.featuresFiltersState;
  const {wizardPopupGroup} = store.wizardState;

  return {
    filterVisible,
    selectedFilters,
    wizardPopupGroup,
  };
};

const mapDispatchToProps = {
  setFilterVisible
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardPopupEntitiesExclusionTopFilters)
)
